export enum Roles {
  READ_ONLY_ROLE = 'Read Only',
  PBM = 'PBM',
  SUPER_ADMIN_ROLE = 'SuperAdmin',
  PARTNER_USER = 'Partner User',
  PROSPECT_PARTNER_USER = 'Prospect Partner User',
  EXCEPTION_USER = 'Exception User',
  EXCEPTION_READ_ONLY = 'Exception Read Only',
  CC_DEVELOPER = 'CC Developer',
  PROFILING = 'Profiling',
  LEGAL_APPROVER = 'LegalApprover',
  CONTRACT_OPERATIONS = 'Contract Operations',
  COMMUNICATION_PREFERENCE = 'Communication Preference',
  TOOLS_SUPPORT = 'Tools Suppot',
  AOM = 'AOM',
  RAM = 'RAM',
  ADMIN = 'Admin',
  CSI = 'CSI',
  HP_MGMT = 'HPManagement',
  IPBM = 'iPBM',
  ONBOARDING_ADMIN = 'OnboardingAdmin',
  BP_ADMIN = 'BPAdmin',
  PROXIMITY = 'Proximity',
  SPV_TR = 'SPV_Proximity',
  SPV_CSI = 'SPV-CSI',
  SPV_IPBM = 'SPV-iPBM',
  PARTNER_CONTRACT_REQUEST_CREATION = 'Partner Contract Request Creation',
  TRANSACTIONAL_MANAGER = 'Transactional Manager',
  SC_ADMIN = 'SC Admin',
  SERVICES_CHAMP = 'Services Champ',
}
